"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var credit_card_icon_1 = require("../credit_cards/legacy/credit_card_icon");
function renderCardSummary(creditCard) {
    var cardAbout = creditCard.cardType + " ...." + creditCard.last4;
    var expiryDate = creditCard.expirationMonth + "/" + creditCard.expirationYear;
    return (React.createElement("div", { className: "cc-details__card-info" },
        React.createElement("div", { className: "cc-details__card-type" }, cardAbout),
        React.createElement("div", { className: "cc-details__expiration" }, I18n.t('discovery.selectableCreditCardList.expiresOn', { date: expiryDate }))));
}
function PrimaryBillingMethod(props) {
    var creditCard = props.creditCard;
    function handleChangeButtonClick(event) {
        event.preventDefault();
        props.onChangeButtonClick();
    }
    return (React.createElement("li", { className: "shop-onboarding__card", key: creditCard.id, id: "credit_card_" + creditCard.id },
        React.createElement("label", { className: "boxed-list__item boxed-list__item" },
            React.createElement("div", { className: "cc-details" },
                React.createElement("div", { className: "cc-details__card" },
                    React.createElement("div", { className: "cc-details__icon" },
                        React.createElement(credit_card_icon_1.default, { cardType: creditCard.cardType })),
                    renderCardSummary(creditCard)),
                React.createElement("button", { className: "button-as-link boxed-list__action", type: "button", onClick: handleChangeButtonClick }, I18n.t('discovery.selectableCreditCardList.change'))))));
}
exports.default = PrimaryBillingMethod;
//# sourceMappingURL=primary_billing_method.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/billing/primary_billing_method.js
// module id = +mOD
// module chunks = 20 21